import { useSpinDelay } from 'spin-delay'
import { cn } from '#app/utils/misc'
import { Button, type ButtonVariant } from './button'
import { Icon } from './icon'
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from './tooltip'

export const StatusButton = ({
	message,
	status,
	className,
	children,
	spinDelay,
	...props
}: React.ComponentProps<'button'> &
	ButtonVariant & {
		status: 'pending' | 'success' | 'error' | 'idle'
		message?: string | null
		spinDelay?: Parameters<typeof useSpinDelay>[1]
	}) => {
	const delayedPending = useSpinDelay(status === 'pending', {
		delay: 400,
		minDuration: 300,
		...spinDelay,
	})
	const companion = {
		error: (
			<div className="inline-flex size-6 items-center justify-center rounded-full bg-destructive">
				<Icon
					className="text-destructive-foreground"
					name="cross-1"
					title="Error"
				/>
			</div>
		),
		idle: null,
		pending: delayedPending ? (
			<div className="inline-flex size-6 items-center justify-center">
				<Icon className="animate-spin" name="update" title="Loading" />
			</div>
		) : null,
		success: (
			<div className="inline-flex size-6 items-center justify-center">
				<Icon name="check" title="Success" />
			</div>
		),
	}[status]

	return (
		<Button className={cn('flex justify-center gap-4', className)} {...props}>
			<div>{children}</div>
			{message ? (
				<TooltipProvider>
					<Tooltip>
						<TooltipTrigger>{companion}</TooltipTrigger>
						<TooltipContent>{message}</TooltipContent>
					</Tooltip>
				</TooltipProvider>
			) : (
				companion
			)}
		</Button>
	)
}
StatusButton.displayName = 'Button'
